module.exports = __webpack_public_path__ + "static/media/user.3c183c76.svg";